export class ExpiryDateModel {
cmbExpiryDate: string;
setValue(res){
if(res){
if(res['cmbExpiryDate']){this.cmbExpiryDate = res['cmbExpiryDate'];}
}
}
}